import { render } from "./SocialShare.vue?vue&type=template&id=252fee72&ts=true"
import script from "./SocialShare.vue?vue&type=script&lang=ts"
export * from "./SocialShare.vue?vue&type=script&lang=ts"

import "./SocialShare.vue?vue&type=style&index=0&id=252fee72&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__